// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  background-color: var(--white);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.control-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 20px;
  border: none;
  border-radius: 12px;
  background-color: var(--secondary-blue);
  color: var(--white);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 24px;
}

.control-btn:hover {
  background-color: var(--primary-blue);
  transform: translateY(-2px);
}

.control-btn.active {
  background-color: var(--secondary-red);
}

.control-btn.active:hover {
  background-color: var(--primary-red);
}

.control-btn.screen-share {
  background-color: var(--success);
}

.control-btn.screen-share:hover {
  background-color: #16a34a;
}

.control-btn.leave-btn {
  background-color: var(--secondary-red);
}

.control-btn.leave-btn:hover {
  background-color: var(--primary-red);
}

.control-btn.recording-btn {
  background-color: var(--success);
}

.control-btn.recording-btn:hover {
  background-color: #16a34a;
}

.control-btn.recording-btn.recording {
  background-color: var(--secondary-red);
  animation: pulse 1.5s infinite;
}

.control-btn.recording-btn.recording:hover {
  background-color: var(--primary-red);
}

.recording-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.recording-timer {
  font-size: 11px;
  font-weight: 600;
  color: #ffffff;
  background: rgba(220, 38, 38, 0.85);
  padding: 2px 8px;
  border-radius: 999px;
  line-height: 1.4;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.control-btn.end-meeting-btn {
  background-color: var(--secondary-red);
}

.control-btn.end-meeting-btn:hover {
  background-color: var(--primary-red);
}

.control-btn.hand-raised {
  background-color: #f59e0b;
}

.control-btn.hand-raised:hover {
  background-color: #d97706;
}

.control-btn.share-link-btn {
  background-color: var(--success);
}

.control-btn.share-link-btn:hover {
  background-color: #16a34a;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(220, 38, 38, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0);
  }
}

.control-label {
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .controls {
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 10px;
  }

  .control-btn {
    padding: 8px 10px;
    font-size: 18px;
    border-radius: 10px;
  }

  .control-label {
    font-size: 10px;
  }
}

@media (max-width: 380px) {
  .controls {
    flex-wrap: wrap;
    gap: 4px;
    padding: 8px 6px;
    justify-content: center;
  }

  .control-btn {
    padding: 6px 8px;
    font-size: 16px;
    border-radius: 8px;
  }

  .control-label {
    display: none;
  }
}

@media (max-width: 320px) {
  .controls {
    gap: 2px;
    padding: 6px 4px;
  }

  .control-btn {
    padding: 4px 6px;
    font-size: 14px;
    border-radius: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Controls.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".controls {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 16px;\r\n  padding: 16px 24px;\r\n  background-color: var(--white);\r\n  border-radius: 16px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.control-btn {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 12px 20px;\r\n  border: none;\r\n  border-radius: 12px;\r\n  background-color: var(--secondary-blue);\r\n  color: var(--white);\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  font-size: 24px;\r\n}\r\n\r\n.control-btn:hover {\r\n  background-color: var(--primary-blue);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.control-btn.active {\r\n  background-color: var(--secondary-red);\r\n}\r\n\r\n.control-btn.active:hover {\r\n  background-color: var(--primary-red);\r\n}\r\n\r\n.control-btn.screen-share {\r\n  background-color: var(--success);\r\n}\r\n\r\n.control-btn.screen-share:hover {\r\n  background-color: #16a34a;\r\n}\r\n\r\n.control-btn.leave-btn {\r\n  background-color: var(--secondary-red);\r\n}\r\n\r\n.control-btn.leave-btn:hover {\r\n  background-color: var(--primary-red);\r\n}\r\n\r\n.control-btn.recording-btn {\r\n  background-color: var(--success);\r\n}\r\n\r\n.control-btn.recording-btn:hover {\r\n  background-color: #16a34a;\r\n}\r\n\r\n.control-btn.recording-btn.recording {\r\n  background-color: var(--secondary-red);\r\n  animation: pulse 1.5s infinite;\r\n}\r\n\r\n.control-btn.recording-btn.recording:hover {\r\n  background-color: var(--primary-red);\r\n}\r\n\r\n.recording-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.recording-timer {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  background: rgba(220, 38, 38, 0.85);\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  line-height: 1.4;\r\n  letter-spacing: 0.04em;\r\n  white-space: nowrap;\r\n}\r\n\r\n.control-btn.end-meeting-btn {\r\n  background-color: var(--secondary-red);\r\n}\r\n\r\n.control-btn.end-meeting-btn:hover {\r\n  background-color: var(--primary-red);\r\n}\r\n\r\n.control-btn.hand-raised {\r\n  background-color: #f59e0b;\r\n}\r\n\r\n.control-btn.hand-raised:hover {\r\n  background-color: #d97706;\r\n}\r\n\r\n.control-btn.share-link-btn {\r\n  background-color: var(--success);\r\n}\r\n\r\n.control-btn.share-link-btn:hover {\r\n  background-color: #16a34a;\r\n}\r\n\r\n@keyframes pulse {\r\n  0% {\r\n    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7);\r\n  }\r\n  70% {\r\n    box-shadow: 0 0 0 10px rgba(220, 38, 38, 0);\r\n  }\r\n  100% {\r\n    box-shadow: 0 0 0 0 rgba(220, 38, 38, 0);\r\n  }\r\n}\r\n\r\n.control-label {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .controls {\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n    padding: 10px 10px;\r\n  }\r\n\r\n  .control-btn {\r\n    padding: 8px 10px;\r\n    font-size: 18px;\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .control-label {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n@media (max-width: 380px) {\r\n  .controls {\r\n    flex-wrap: wrap;\r\n    gap: 4px;\r\n    padding: 8px 6px;\r\n    justify-content: center;\r\n  }\r\n\r\n  .control-btn {\r\n    padding: 6px 8px;\r\n    font-size: 16px;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .control-label {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 320px) {\r\n  .controls {\r\n    gap: 2px;\r\n    padding: 6px 4px;\r\n  }\r\n\r\n  .control-btn {\r\n    padding: 4px 6px;\r\n    font-size: 14px;\r\n    border-radius: 6px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
